import React from "react";
import { CartEmptyDisclamerLabels, CartEmptyDisclamerPropTypes } from "./types";
import Button from "../Button";

const CartEmptyDisclamer = ({ labels }) => {
    return (
        <div className="cart-empty-disclamer">
            <span>{labels.disclamer}</span>
            <Button
                size="SM"
                label="Jetzt Produkte hinzufügen"
                href="/shop/bowls"
            />
        </div>
    );
};

CartEmptyDisclamer.propTypes = CartEmptyDisclamerPropTypes;
CartEmptyDisclamer.defaultProps = {
    labels: CartEmptyDisclamerLabels,
};
export default CartEmptyDisclamer;
